import { type IGaUser } from 'shared/types/user/gaUser';
import { type IFastFiltersUserSchema } from 'shared/repositories/monolith-python/entities/schemas/FastFiltersUserSchema';

export function createGaUser(user: IFastFiltersUserSchema | null | undefined): IGaUser {
  if (!user?.isAuthenticated) {
    return { type: 'not_authorized' };
  }

  const { id: cianUserId, userType: type, tariff: tarif, balance, userId } = user;

  return {
    balance,
    cianUserId,
    tarif,
    type,
    userId,
  };
}
